import { message } from "antd";
import { axiosPost } from "../axios";

export const inviteMember = async (payload) => {
  try {
    const res = await axiosPost({
      path: "user/members/invite",
      payload: payload,
    });
    return res;
  } catch (error) {
    message.error(error.response.data.message);
  }
};
